export default {
  namespaced: true,
  state: {
  },
  getters: {
  },
  mutations: {
  },
  actions: {
    getCourses () {
      const promise = this.server.courseList()
      return promise
    },
    getById (context, payload) {
      const promise = this.server.courseById(payload)
      return promise
    },
    getChapters (context, payload) {
      console.log(payload)
      const promise = this.server.chapterList(payload)
      return promise
    },
    add (context, payload) {
      const promise = this.server.addCourse(payload)
      return promise
    },
    update (context, payload) {
      const promise = this.server.updateCourse(payload)
      return promise
    },
    remove (context, payload) {
      const promise = this.server.deleteCourse(payload)
      return promise
    },
    getQuestions (context, payload) {
      console.log(payload)
      const promise = this.server.questionList(payload)
      return promise
    }
  }
}
